/*
 * Copyright (c) 2024. Haodong JU
 */

import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { reservationLocalHost } from '@/model/dataLayer/api/newReservation/reservation'

const url = reservationLocalHost + '/settings/personRule/'

export async function savePersonRule (item) {
  return (await hillo.jsonPost(url + 'save', {
    ...item,
    deviceId: await getCurrentDeviceId()
  }))
}

export async function deletePersonRule (id) {
  return (await hillo.post(`${url}${id}/delete`, {}))
}

export async function getPersonRules () {
  return (await hillo.get(url + await getCurrentDeviceId(), {})).data
}
